import React from 'react'

import BoatDebugLogsScreen from './BoatDebugLogsScreen'

export default {
  id : 'siren.boat.DebugLogs.GroupScreen',
  matches : { client : 'ItemScreen', path : 'boat', objectType : 'boat' },
  exact : true,
  path : '/p/:persona/boat/:boatId/debugLogs',
  default : false,
  render : ctx => React.createElement( BoatDebugLogsScreen, ctx )
}
